import { render, staticRenderFns } from "./statisticsBacthGoods.vue?vue&type=template&id=d88a4568&scoped=true&"
import script from "./statisticsBacthGoods.vue?vue&type=script&lang=js&"
export * from "./statisticsBacthGoods.vue?vue&type=script&lang=js&"
import style0 from "./statisticsBacthGoods.vue?vue&type=style&index=0&id=d88a4568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88a4568",
  null
  
)

export default component.exports